import Vue from "vue";
import VueRouter from "vue-router";
import Cookie from "js-cookie";

import Home from "../pages/Home.vue";
import User from "../pages/User.vue";
import Main from "../pages/Main.vue";
import Mall from "../pages/Mall.vue";
import Login from "../pages/Login.vue";
import PageOne from "../pages/PageOne.vue";
import ClassList from "../pages/ClassList.vue";
import adminList from "../pages/adminList.vue";
import Banner from "../pages/Banner.vue";

import NotFound from "../pages/NotFound.vue";

Vue.use(VueRouter);
const routers = [
  {
    name: "main",
    path: "/",
    redirect: "/home",
    component: Main,
    meta: { title: "首页" },
    children: [
      { name: "home", path: "home", component: Home, meta: { title: "首页" } },
      {
        name: "user",
        path: "user",
        component: User,
        meta: { title: "用户管理" },
      },
      {
        name: "mall",
        path: "mall",
        component: Mall,
        meta: { title: "商品管理" },
      },
      {
        name: "ClassList",
        path: "ClassList",
        component: ClassList,
        meta: { title: "商品分类" },
      },
      {
        name: "adminList",
        path: "adminList",
        component: adminList,
        meta: { title: "管理员列表" },
      },
      {
        name: "Banner",
        path: "Banner",
        component: Banner,
        meta: { title: "Banner列表" },
      },
      {
        name: "page1",
        path: "page1",
        component: PageOne,
        meta: { title: "页面1" },
      },
    ],
  },
  {
    name: "login",
    path: "/login",
    component: Login,
  },
  {
    path: "*",
    component: NotFound,
  },
];
const router = new VueRouter({
  routes: routers,
});

//添加全局前置路由守卫
router.beforeEach((to, from, next) => {
  //判断token是否存在
  const token = Cookie.get("token");
  if (!token && to.name !== "login") {
    next({ name: "login" });
  } else if (token && to.name === "login") {
    next({ name: "home" });
  } else {
    next();
  }
});

// router.addChildrenRoute = (router) => {
//   if (!Cookie.get("menu")) {
//     return;
//   }
//   const menu = JSON.parse(Cookie.get("menu"));
//   //组装动态路由数据
//   const menuArray = [];
//   menu.forEach((item) => {
//     if (item.children) {
//       item.children = item.children.map((item) => {
//         item.component = () => import(`@/pages/${item.url}`);
//         item.meta = { title: item.label };
//         return item;
//       });
//       menuArray.push(...item.children);
//     } else {
//       item.component = () => import(`@/pages/${item.url}`);
//       item.meta = { title: item.label };
//       menuArray.push(item);
//     }
//   });
//   menuArray.forEach((item) => {
//     router.addRoute("main", item);
//   });
// };

router.resetRouter = function () {
  const newRouter = new VueRouter({
    routes: routers,
  });
  this.matcher = newRouter.matcher; //替换成新的空路由
};

export default router;
